import { h, Component } from 'preact';
import { connect } from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import MenuObject from '../canvas/menu-object';

export default @connect(reduce, actions)
class MenuObjectModifierDividers extends Component {
  constructor(props) {
    super();
  }

  updateModifierDivider(char) {
    MenuObject.updateModifierDivider(this.props.$element, char);
    this.props.setModifierDivider(char);
  }

  render(props, state) {
    return (
      <div className="priceDividerContainer">
        {props.label !== "Tag" && <h5>Modifier Dividers</h5>}
        <ul>
          <li className={`${props.modifierDivider === "0002F" ? 'act' : ''} option`}>
            <a className={"icn"} onClick={() => this.updateModifierDivider("0002F")}>
              &#47;
            </a>
          </li>
          <li className={`${props.modifierDivider === "0005C" ? 'act' : ''} option`}>
            <a className={"icn"} onClick={() => this.updateModifierDivider("0005C")}>
              &#92;
            </a>
          </li>
          <li className={`${props.modifierDivider === "02022" ? 'act' : ''} option`}>
            <a className={"icn"} onClick={() => this.updateModifierDivider("02022")}>
              &bull;
            </a>
          </li>
          <li className={`${props.modifierDivider === "0007C" ? 'act' : ''} option`}>
            <a className={"icn"} onClick={() => this.updateModifierDivider("0007C")}>
              &#124;
            </a>
          </li>
          <li className={`${props.modifierDivider === "" ? 'act' : ''} option none`}>
            <a className={"icn"} onClick={() => this.updateModifierDivider("")}>
              NONE
            </a>
          </li>
        </ul>
      </div>
    )
  }
}
